import { persistCombineReducers } from 'redux-persist';
import { queuesCommonPersisConfig } from 'store/persistConfig';

import services from './services';
import appointmentInfo from './appointmentInfo';
import appointmentForm from './appointmentForm';
import updatedAvailability from './updatedAvailability';

export default persistCombineReducers(queuesCommonPersisConfig, {
  services,
  appointmentForm,
  appointmentInfo,
  updatedAvailability,
});
